import axios from "axios";

// 아파치가 /sms-ui/ 를 노드 서버(:5000) 루트로 넘긴다 (vhost.conf ProxyPass)
const api = axios.create({ baseURL: "/sms-ui", withCredentials: true });

export default api;

export function ymd(d) {
  const p = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

export function daysAgo(n) {
  const d = new Date();
  d.setDate(d.getDate() - n);
  return d;
}

// 서버가 주는 20260824121057 을 사람이 읽는 꼴로
export function prettyStamp(s) {
  const v = String(s || "").replace(/\D/g, "");
  if (v.length < 14) return s || "";
  return `${v.slice(0, 4)}-${v.slice(4, 6)}-${v.slice(6, 8)} ${v.slice(8, 10)}:${v.slice(10, 12)}:${v.slice(12, 14)}`;
}

export function prettyPhone(p) {
  const v = String(p || "").replace(/\D/g, "");
  if (v.length === 11) return `${v.slice(0, 3)}-${v.slice(3, 7)}-${v.slice(7)}`;
  if (v.length === 10) return `${v.slice(0, 3)}-${v.slice(3, 6)}-${v.slice(6)}`;
  return p || "";
}

// EUC-KR 기준 바이트 (서버 판정과 같은 규칙)
export function euckrBytes(text) {
  let n = 0;
  for (const ch of String(text || "")) n += ch.codePointAt(0) > 0x7f ? 2 : 1;
  return n;
}
